// Formattazione della sezione Analytics (visite mensili per pagina)

const decimale = n => n.toLocaleString('it-IT', { maximumFractionDigits: 1 });

// 999 -> "999", 1234 -> "1,2k", 15400 -> "15k", 1250000 -> "1,3M"
export const formatK = valore => {
	const n = Math.round(+valore || 0);
	if (Math.abs(n) < 1000) return String(n);
	const k = Math.abs(n) >= 10000 ? Math.round(n / 1000) : Math.round(n / 100) / 10;
	// 999.999 arrotonda a 1000k: si passa ai milioni
	if (Math.abs(k) < 1000) return `${decimale(k)}k`;
	return `${decimale(Math.round(n / 100000) / 10)}M`;
};

// 'YYYY-MM' -> "ott 25"
export const etichettaMese = month => {
	const [y, m] = String(month).split('-').map(Number);
	const nome = new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString('it-IT', { month: 'short', timeZone: 'UTC' }).replace('.', '');
	return `${nome} ${String(y).slice(2)}`;
};

// 'YYYY-MM' -> "ottobre 2025"
export const meseEsteso = month => {
	const [y, m] = String(month).split('-').map(Number);
	return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString('it-IT', { month: 'long', year: 'numeric', timeZone: 'UTC' });
};

let nomiLingue = null;
// 'en' -> "Inglese"
export const nomeLingua = codice => {
	try {
		if (!nomiLingue) nomiLingue = new Intl.DisplayNames(['it'], { type: 'language' });
		const nome = nomiLingue.of(codice) || codice;
		return nome.charAt(0).toUpperCase() + nome.slice(1);
	} catch (e) {
		return String(codice).toUpperCase();
	}
};
